module.exports = __webpack_public_path__ + "static/media/login (1).8fec5c64.svg";